var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('add-or-edit', {
    attrs: {
      "type": _vm.$enum.common.ModalTypeEnum.ADD,
      "isTransform": true
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };